<ion-content [fullscreen]="true">
  <ion-refresher
    id="refresher"
    slot="fixed"
    (ionRefresh)="doRefresh($event)"
    [disabled]="!this.platform.is('capacitor')"
  >
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  <ion-grid>
    <ion-row>
      <ion-col>
        <app-info-varsling-popup
          *ngFor="let i = index; let message; of: infoMessages"
          [popupId]="i"
          [message]="message"
        ></app-info-varsling-popup>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-title>
          <!-- Strømregninger -->
          <h1>Strøm&#173;regninger</h1>
        </ion-title>
      </ion-col>
    </ion-row>

    <!-- Anlegg -->
    @if (hasFetchedAvtaler && avtaler){
    <app-anlegg
      [_showAnleggsliste]="_showAnleggsliste"
      [anleggList]="anleggList | async"
      [valgtAnlegg]="valgtAnlegg"
      [anleggIsInactive]="anleggIsInactive"
      [mineAvtaler]="avtaler"
      [showMPID]="_showMPID"
      (outAnlegg)="setAnlegg($event)"
    ></app-anlegg>
    }

    <ion-row *ngIf="!hasFetchedRegninger && valgtAvtale === null">
      <ion-col>
        <ng-container
          [ngTemplateOutlet]="loadingTemplate"
          [ngTemplateOutletContext]="{
              isBlue: true
            }"
        ></ng-container>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="hasFetchedRegninger && valgtAvtale === null">
      <ion-col class="ingen-avtale-boks mt-4">
        <p>Vi finner ingen aktive avtaler for din bruker.</p>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col class="ion-padding regninger-liste-container" size="12">
        <div
          *ngIf="hasFetchedRegninger && fakturaList?.length === 0"
          class="pText"
        >
          <div class="fakt_year_header">&nbsp;</div>
          <p>Her var det tomt!</p>
          <p>
            Er du ny kunde hos oss? Da dukker din første regning opp her så
            snart vi sender den til deg.
          </p>
        </div>

        <!-- liste over regninger-->

        <div *ngIf="showPlaceholderRegning && valgtAvtale" class="fakturaboks">
          <div class="fakt_year_header">Din neste regning</div>
          <ion-row
            class="ion-align-items-center faktura-linje placeholder-linje m-b ion-center-content"
            tabindex="0"
          >
            <ion-col class="flex">
              <div class="align-fakt-text">
                <ion-icon
                  class="img_icon orange"
                  name="close-circle-outline"
                ></ion-icon>
              </div>
              <div class="align-fakt-text">
                <div class="mediumFont">
                  Periode
                  <span class="faktura-period-string mediumFont">
                    {{ getFakturaPeriodString(placeholderFrom, placeholderTo) }}
                  </span>
                </div>
                <div>
                  Regningen er ikke helt klar enda, men vi jobber med saken!
                </div>
              </div>
            </ion-col>
          </ion-row>
        </div>

        <div *ngFor="let faktura of fakturaList" class="fakturaboks">
          <div *ngIf="faktura.yr" class="fakt_year_header">
            {{ faktura.yr }}
          </div>

          <ion-row
            *ngIf="faktura.maalepunktid === valgtAnlegg.maalepunktid"
            class="ion-align-items-center faktura-linje m-b ion-center-content"
            (click)="openRegningModal(faktura.fakturanr) "
            tabindex="0"
          >
            <ion-col class="flex">
              <div class="align-fakt-text">
                <ion-icon
                  class="img_icon"
                  [class.orange]="
                      !harRegningForfalt(faktura) && !erRegningBetalt(faktura)
                    "
                  [class.red]="
                      harRegningForfalt(faktura) && !erRegningBetalt(faktura)
                    "
                  [name]="
                      faktura.status.trim() === 'Ikke betalt'
                        ? 'close-circle-outline'
                        : 'checkmark-circle-outline'
                    "
                ></ion-icon>
              </div>
              <div class="align-fakt-text">
                <div class="mediumFont">
                  Periode
                  <span class="faktura-period-string mediumFont">
                    {{ getFakturaPeriodString(faktura.fradato, faktura.tildato)
                    }}
                  </span>
                </div>
                <div *ngIf="!(faktura.status.trim() === 'Ikke betalt')">
                  {{ faktura.status }}
                </div>
                <div *ngIf="faktura.status.trim() === 'Ikke betalt'">
                  {{ dagerTilForfallTekst(faktura) }}
                </div>
              </div>
            </ion-col>
            <ion-col size="4" class="ion-text-right ion-padding-end">
              <ion-row>
                <ion-col>
                  <div class="align-fakt-text">{{ faktura.belopNo }} kr</div>
                </ion-col>
              </ion-row>
            </ion-col>
            <ion-col size="1">
              <ion-icon
                class="ion-float-right"
                name="chevron-forward-outline"
                style="margin-bottom: 7px"
              ></ion-icon>
            </ion-col>
          </ion-row>
          <ion-modal
            #fakturapopupmodal
            [isOpen]="showRegningModal === faktura.fakturanr"
            cssClass="show-regning-modal-content"
            backdropDismiss
            (didDismiss)="showRegningModal = undefined"
          >
            <ng-template>
              <app-faktura-popup
                [faktura]="faktura"
                (dueDateChanged)="fetchRegninger()"
                (openPdfOutside)="openPdf($event)"
              ></app-faktura-popup>
            </ng-template>
          </ion-modal>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div class="tab-content-bottom-margin"></div>
</ion-content>

<ng-template #loadingTemplate let-isBlue="isBlue">
  <div class="spinner" [class.blueColor]="isBlue">
    <ion-spinner name="dots"></ion-spinner>
  </div>
</ng-template>
